module.exports = __webpack_public_path__ + "static/logo512-62a57ddd967199348bc45e40ce64cacf.png";